// Dhara js
window.onload = function(){
    if($(window).width() > 991){
        $('.collection-list-new-template .collections-list .tending_imageblock .grid__image a img').matchHeight({
            byRow: false
        });
        $('.collection-list-new-template .collections-list .skrim__title .skrim__underline-me .collection_info_title_2').matchHeight({
            byRow: false
        });
        $('.collection-list-new-template .collections-list .skrim__title .description').matchHeight({
            byRow: true
        });
    }
}
// Dhara js

$(document).ready(function() {    
    /* Every time the window is scrolled ... */
    $(window).scroll( function(){    
        /* Check the location of each desired element */
        $('.section-block-collection').each( function(i){            
            var bottom_of_object = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();            
            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window > bottom_of_object ){                
                $(this).animate({'opacity':'1'},300);                    
            }            
        });     
    });    
});

// update progress bar
$(document).ready(function(){
    var total_number_items = $('.price_view').data('total-counts');
    var total_updated_number = $('.total-counts').html();
    var total_added = total_updated_number / total_number_items;
    $('.progressbar>span').css("width",total_added * 100 + '%');;
  });

// Load more blog journal
$(document).ready(function(){        
    $('.load_more_btn_new').on("click",function(e){
      e.preventDefault();
      var ajax_url = "";
      var final_items = "";
      $('.load_more').fadeIn(500);
      ajax_url = $(this).attr('href');
      $.ajax({
        type: 'GET',
        url: ajax_url,        
        success: function(data) {            
            $('.load_more').fadeOut(500); 
            var filteredData = $(data).find(".grid-masonry.page-width.grid__item_row").html(); 
            $(".grid-masonry.page-width.grid__item_row").append(filteredData);
            final_items = $(".grid-masonry.page-width.grid__item_row").find(".masonry-item").length;            
            console.log('here' + final_items);
            $('.total-counts').html(final_items);  
            var total_number_items = $('.price_view').data('total-counts');
            var total_updated_number = $('.total-counts').html();
            var total_added = total_updated_number / total_number_items;
            $('.progressbar>span').css("width",total_added * 100 + '%');
            $('.blog_content_wrapper .three_blogimages_wrapper .heading_center .listing_tag').matchHeight({
              byRow: false,
            });
            $('.blog_content_wrapper .filter_content_wrapper .masonry-item .img_wrap').matchHeight({
              byRow: false,
            });
            $('.blog_content_wrapper .three_blogimages_wrapper .heading_center h4 a').matchHeight({
              byRow: true,
            });
            if( $(data).find(".load_more_btn_new").length) {
                $(".load_more_btn_new").attr('href',$(data).find(".load_more_btn_new").attr('href')); 
            }else{
              $(".load_more_btn_new").hide(200);
            }                   
        },          
      });
    });
    if($(window).width() > 767){
      $('.blog_content_wrapper .three_blogimages_wrapper .heading_center .listing_tag').matchHeight({
        byRow: true,
      });
      $('.blog_content_wrapper .filter_content_wrapper .masonry-item .img_wrap').matchHeight({
        byRow: true,
      });
      $('.blog_content_wrapper .three_blogimages_wrapper .heading_center h4 a').matchHeight({
        byRow: true,
      });
    }
  });

// Load more product grid_view
$('.load_more_btn').on("click",function(e){
    e.preventDefault();
    var ajax_url = "";
    var final_items = "";
    ajax_url = $(this).attr('href');
    $('.load_more').fadeIn(500);
    $.ajax({
      type: 'GET',
      url: ajax_url,        
      success: function(data) {
          $('.load_more').fadeOut(500); 
          var filteredData = $(data).find(".grid.grid--uniform.collection_productlist_wrapper.collection_gridview").html(); 
          $(".grid.grid--uniform.collection_productlist_wrapper.collection_gridview").append(filteredData);
          final_items = $(".grid.grid--uniform.collection_productlist_wrapper.collection_gridview").find(".grid__item.grid_wrape.collection_productcol.grid-product").length;            
          console.log('here' + final_items);
          $('.total-counts').html(final_items);  
          var total_number_items = $('.price_view').data('total-counts');
          var total_updated_number = $('.total-counts').html();
          var total_added = total_updated_number / total_number_items;
          $('.progressbar>span').css("width",total_added * 100 + '%');
          if( $(data).find(".load_more_btn").length) {
              $(".load_more_btn").attr('href',$(data).find(".load_more_btn").attr('href')); 
          }else{
            $(".load_more_btn").hide(200);
          }                   
      },             
    });
  });


// Load more product list_view

$('.load_more_btn_list').on("click",function(e){
    e.preventDefault();
    var ajax_url = "";
    var final_items = "";
    $('.load_more').fadeIn(500);
    ajax_url = $(this).attr('href');
    $.ajax({
      type: 'GET',
      url: ajax_url,        
      success: function(data) {
          $('.load_more').fadeOut(500); 
          var filteredData = $(data).find(".grid.grid--uniform.collection_productlist_wrapper.collection_listview").html(); 
          $(".grid.grid--uniform.collection_productlist_wrapper.collection_listview").append(filteredData);
          final_items = $(".grid.grid--uniform.collection_productlist_wrapper.collection_listview").find(".grid__item.grid-product.product-grid-item").length;            
          console.log('here' + final_items);
          $('.total-counts').html(final_items);
          var total_number_items = $('.price_view').data('total-counts');
          var total_updated_number = $('.total-counts').html();
          var total_added = total_updated_number / total_number_items;
          $('.progressbar>span').css("width",total_added * 100 + '%');
          if( $(data).find(".load_more_btn_list").length) {
              $(".load_more_btn_list").attr('href',$(data).find(".load_more_btn").attr('href')); 
          }else{
            $(".load_more_btn_list").hide(200);
          }                   
      },             
    });
  });
// hide and show loadmore button

$(document).ready(function(){
    $('.productsorting_rightwrap .product_list a').on('click' , function(e){
      e.preventDefault();
      var $this = $(this);
      var currentid = $this.attr('href');    
       console.log(currentid);
    if(currentid == '#collectionin_list'){
      $("#collectionin_grid_btn").show();
      $("#collectionin_list_btn").hide();
      console.log("gridview-show");
    }else{
  
      $("#collectionin_list_btn").show();
      $("#collectionin_grid_btn").hide();
       console.log("listview-show");
  
    }
    });
    $('.testimonials-slider__text').matchHeight();
    $('.testimonials-slider__text .testimonial_block').matchHeight();
});


// js added for contact form checkbox icon issue code start here

$(document).ready(function() {
  $('.contact-page-form-submit input[name="respondBy[]"]').click(function(){
    if($(this).is(':checked')){
        $(this).parents('.state').find('.image').css('display','block');
    } else{
        $(this).parents('.state').find('.image').css('display','none');
    }
  });   
});

// js added for contact form checkbox icon issue code end here

